import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import TextSearch from '../../Components/TextSearch';
import TransactionTableHeader from '../../Transactions/TransactionTableHeader';
import headers from './TransactionGroupFailedReportHeaderData.json';
import getAxiosClient from '../../Utilities/get-axios-client';
import PaginationElement from '../../Components/PaginationElement';
import GroupReportChartOptions from '../GroupReportChartOptions.json';
import TransactionGroupFailedReportTableBody from './TransactionGroupFailedReportTableBody';
import FailedGroupReportHeaderStats from './FailedGroupReportHeaderStats';
import { defaultSearchQuery, getGroupStatsQuery } from '../TransactionGroupReportHandler';
import TransactionGroupReportElement from '../TransactionGroupReportElement';
import { reportStartDate, reportEndDate } from '../../Utilities/date-format';

class TransactionGroupFailedReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionResponse: {},
      chartOptions: GroupReportChartOptions,
      searchQuery: { report_type: 'failed', ...defaultSearchQuery() },
      dateRange: {},
    };
    this.groupElementRef = React.createRef();
  }

  async componentDidMount() {
    const dateRange = this.groupElementRef.current.dateValue;
    this.updateDateRange(dateRange);
    await this.getGroupStats(
      getGroupStatsQuery(
        'failed',
        reportStartDate(dateRange.start),
        reportEndDate(dateRange.end),
      ),
    );
  }

  async getGroupStats(groupStatsQuery) {
    try {
      const response = await getAxiosClient()
        .post('v1/transaction-groups/reports', { ...groupStatsQuery });
      this.setState({
        transactionResponse: response.data.transactions,
      });
      const days = response.data.dailyStats.map((dailyStat) => dailyStat.tstat_day);
      const sent = response.data.dailyStats.map((dailyStat) => +dailyStat.sent);
      const failed = response.data.dailyStats.map((dailyStat) => +dailyStat.failed);
      await this.setState((previousState) => ({
        chartOptions: {
          ...previousState.chartOptions,
          xAxis: {
            categories: days,
          },
          series: [{
            name: 'Sent',
            data: sent,
            color: '#3b5998',
          }, {
            name: 'Failed',
            data: failed,
            color: '#e74c3c',
          }],
        },
      }));
    } catch (e) {
      // eslint-disable-next-line
    }
  }

  getTransactions = async (searchQuery) => {
    const { dateRange } = this.state;
    const startDate = reportStartDate(dateRange.start);
    const endDate = reportEndDate(dateRange.end);
    const searchQueryUpdated = {
      ...searchQuery,
      start_date: startDate,
      end_date: endDate,
    };

    const response = await getAxiosClient().post(
      'v1/transaction/search',
      searchQueryUpdated,
      { withCredentials: true },
    );
    this.setState({ transactionResponse: response?.data ?? null });
  }

  setCurrentDateRangeValue = async (dateRange) => {
    const { searchQuery } = this.state;
    const updatedSearchQuery = {
      ...searchQuery,
      start_date: dateRange.start.unix(),
      end_date: dateRange.end.unix(),
    };
    await this.setState({ searchQuery: updatedSearchQuery, dateRange });
    await this.getGroupStats(
      getGroupStatsQuery('failed', reportStartDate(dateRange.start), reportEndDate(dateRange.end)),
    );
  };

  sort = async (order, orderBy) => {
    const { searchQuery } = this.state;
    const updatedSearchQuery = {
      ...searchQuery,
      order,
      order_by: orderBy,
      page: 1,
    };
    await this.setState({ searchQuery: updatedSearchQuery });
    await this.getTransactions(updatedSearchQuery);
  };

  setSearchTextValue = async (transactionSearchString, dateRange) => {
    const { searchQuery } = this.state;
    const updatedSearchQuery = {
      ...searchQuery,
      transaction_search_string: transactionSearchString,
      page: 1,
    };
    await this.setState({ searchQuery: updatedSearchQuery, dateRange });
    await this.getTransactions(updatedSearchQuery);
  };

  updateDateRange(dateRange) {
    this.setState((prevState) => ({
      ...prevState,
      dateRange,
    }));
  }

  render() {
    const {
      transactionResponse,
      chartOptions,
      dateRange,
      searchQuery,
    } = this.state;
    const transactionsData = transactionResponse?.data ?? [];
    return (
      <TransactionGroupReportElement
        ref={this.groupElementRef}
        setCurrentDateRangeValue={this.setCurrentDateRangeValue}
        reportType="failed"
        searchQuery={searchQuery}
      >
        <FailedGroupReportHeaderStats dateRange={dateRange} />
        <div className="padding30 border-light top-buffer30">
          <h4 className="bottom-buffer30 top-buffer0">Activity</h4>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
          />
        </div>
        <div>
          <div className="row top-buffer30">
            <div className="col-md-3">
              <TextSearch getTransactions={this.setSearchTextValue} dateRange={dateRange} />
            </div>
          </div>
          <div className="padding10 border-light top-buffer20">
            <table className="table table-striped">
              <TransactionTableHeader sort={this.sort} headers={headers} />
              <TransactionGroupFailedReportTableBody transactionsData={transactionsData} />
            </table>
          </div>
          <PaginationElement
            transactionsResponse={transactionResponse}
            transactionSearchQuery={searchQuery}
            getTransactions={this.getTransactions}
            dateRange={dateRange}
          />
        </div>
      </TransactionGroupReportElement>
    );
  }
}

export default withRouter(TransactionGroupFailedReport);
